import React, {Component} from "react"
import {Grid, Header, Image, Divider, Button} from "semantic-ui-react";
import {NavLink, withRouter} from "react-router-dom";
import {getLocalization, interpolateString, parseMultilineString} from "../../utils/localization";
import {connect} from "react-redux";
import {setPrevRoute} from "../../actions/navigationActions";
import Footer from "../footer";
import moment from "moment";
import {getEffectiveDate} from "../../utils/effectiveDate";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, anualOpenEnrollment} = state;
    return {
        ...ownProps,
        lang: user.lang,
        initialData,
        user,
        anualOpenEnrollment,
        name: anualOpenEnrollment.firstName,
        upcomingPolicyEffectiveDate: state.anualOpenEnrollment.generalInitialData.upcomingPolicyEffectiveDate,
    }
};

class Success extends Component {
    componentDidMount() {
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
    }

    getEffectiveDate() {
        const {
            initialData: {
                contract,
                newNewHireOpenEnrollmentStartDate,
                dateOfHire,
            },
            anualOpenEnrollment: {generalInitialData: { ratedClass }}
        } = this.props;
        const isNewHire = newNewHireOpenEnrollmentStartDate != null
        return getEffectiveDate(contract.policyEffectiveDate, dateOfHire, isNewHire, ratedClass.contractTerms.newHireWaitingPeriod);
    }

    render() {
        const localization = getLocalization(this.props.lang);
        const strings = localization.success;
        const button = (<Button primary content={"Return to my account"} as={NavLink} to={'/plan'}/>)

        return (
            <React.Fragment>
                <div className="member-main-container" style={{background: 'white'}}>
                    <Grid container stackable columns={1} centered>
                        <Grid.Column width={8} className={"pageContent"}>
                            <Grid stackable container style={{marginTop: '5em'}} textAlign={'left'}>
                                <Grid.Row columns={1}>
                                    <Grid.Column>
                                        <Image centered src={'https://brella-platform-assets.s3.amazonaws.com/common/Illustrations/Success-mobile_revision-sign.png'} style={{width: '470px'}}/>
                                    </Grid.Column>
                                    <Grid.Column textAlign={"center"}>
                                        <Header as='h1'>{interpolateString(strings.title, [this.props.name])}</Header>
                                        <p>{strings.description}</p>
                                        <p><b>{strings.yourChanges} {moment(this.props.upcomingPolicyEffectiveDate).format("MMM DD, YYYY")}</b></p>
                                        <p>{parseMultilineString(strings.lookOut)}</p>
                                    </Grid.Column>
                                    <Grid.Column textAlign={"center"}>
                                        <Divider hidden/>
                                        <Header as='h4' style={{marginBottom: '.5em'}}>{strings.allSet}</Header>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Grid.Column>
                    </Grid>
                </div>
                <Footer showTopFooter hasToDisplayCarrierDisclaimer button={button} />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Success));
